import type { AddressPayload, AddressUpdateResponse, AddressValues } from './types';

type FetchArgs = {
  endpoint: string;
  nonce: string;
  type: 'billing' | 'shipping';
};

export async function fetchAddress({ endpoint, nonce, type }: FetchArgs): Promise<AddressPayload> {
  const res = await fetch(`${endpoint}?type=${encodeURIComponent(type)}`, {
    credentials: 'same-origin',
    headers: {
      'X-WP-Nonce': nonce,
    },
  });

  if (!res.ok) {
    throw new Error(`Load failed (${res.status})`);
  }
  return (await res.json()) as AddressPayload;
}

export async function saveAddress({
  endpoint,
  nonce,
  type,
  values,
}: FetchArgs & { values: AddressValues }): Promise<AddressUpdateResponse> {
  const res = await fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': nonce,
    },
    body: JSON.stringify({ type, values }),
  });
  if (!res.ok) {
    throw new Error(`Save failed (${res.status})`);
  }

  return (await res.json()) as AddressUpdateResponse;
}
